<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BDPFUV/tc-custom/9781504081764.jpg?1731838249861" alt="This image is the cover for the book Poetic Diction"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Poetic Diction
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The philosophical treatise on aesthetics and language that inspired T. S. Eliot, C. S. Lewis, and many others.</b></p> In <i>Poetic Diction</i>, Owen Barfield sought to understand why certain groups of words were given the designation of “poetry,” and how they convey meaning and pleasure to the attentive reader. Touching on the philosophy of language and the nature of consciousness, Barfield provides not only a theory of poetic diction, but also a speculation on poetry and knowledge. Ranging across fundamental topics of poetics, Barfield sheds light on the nature of metaphor, aesthetic imagination, the difference between verse and prose, and the essence of meaning itself.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Owen Barfield, Howard Nemerov, Owen Barfield
      </h2>
      
      <p class="authorDescription body article"><P> Owen Barfieldwas a British philosopher, author, poet, critic, and member of the literary discussion group, Inklings.Barfield has been known as &ldquo;the first and last Inkling.&rdquo; He had a profound influence on C. S. Lewis and, through his books <I>The Silver Trumpet</I> and <I>Poetic Diction</I> (dedicated to Lewis), an appreciable effect on J. R. R. Tolkien. Their contributions and conversations persuaded both Tolkien and Lewis that myth and metaphor have always had a central place in language and literature. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cb847044